import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import HomePage, { CategoriesPage } from "@/pages/HomePage";
import SearchPage, { DirectoryPage } from "@/pages/SearchPage";
import CompanyPage from "@/pages/CompanyPage";
import ResourcePage from "@/pages/ResourcePage";
import AuthPage from "@/pages/AuthPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import CustomerPanel from "@/pages/CustomerPanel";
import CompanyPanel from "@/pages/CompanyPanel";
import AdminPanel from "@/pages/AdminPanel";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/ara" element={<SearchPage />} />
              <Route path="/kategoriler" element={<CategoriesPage />} />
              <Route path="/firmalar" element={<DirectoryPage />} />
              <Route path="/firma/:slug" element={<CompanyPage />} />
              <Route path="/firma/:slug/kaynak/:resourceId" element={<ResourcePage />} />
              <Route path="/giris" element={<AuthPage />} />
              <Route path="/kayit" element={<AuthPage />} />
              <Route path="/sifre-sifirla" element={<ResetPasswordPage />} />
              <Route path="/panel" element={<CustomerPanel />} />
              <Route path="/firma-panel" element={<CompanyPanel />} />
              <Route path="/admin" element={<AdminPanel />} />
            </Routes>
          </Layout>
          <Toaster richColors position="top-center" theme="dark" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
